// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3nq2s","colCheckbox":"styles_colCheckbox__5xVqd"};